export const gold = {
  '50': '#f5f0e1',
  '100': '#f9e8b1',
  '200': '#fbde82',
  '300': '#fcd559',
  '400': '#f9ca3a',
  '500': '#f5c023',
  '600': '#efb613',
  '700': '#e1a908',
  '800': '#c99402',
  '900': '#b38300',
};

export const red = {
  '50': '#f5e2e1',
  '100': '#f4b5b2',
  '200': '#f38a85',
  '300': '#f1655e',
  '400': '#ef473e',
  '500': '#ea3127',
  '600': '#e02016',
  '700': '#c9130a',
  '800': '#9b0a03',
  '900': '#730600',
};

export const blueGrey = {
  '50': '#e1e6f5',
  '100': '#c9d3ec',
  '200': '#b1bfe2',
  '300': '#9aabd5',
  '400': '#8496c3',
  '500': '#6e81af',
  '600': '#586a95',
  '700': '#415175',
  '800': '#2d3954',
  '900': '#1c2436',
};

export const blue = {
  '50': '#e1e6f5',
  '100': '#bfcdf2',
  '200': '#9bb2ec',
  '300': '#7b99e3',
  '400': '#6183d6',
  '500': '#4c70c4',
  '600': '#3b5dac',
  '700': '#28488f',
  '800': '#1a3571',
  '900': '#102654',
};

export const green = {
  '50': '#e1f5ed',
  '100': '#caf1e1',
  '200': '#b1ead4',
  '300': '#9be1c5',
  '400': '#85d3b4',
  '500': '#71bfa0',
  '600': '#5da689',
  '700': '#4a886f',
  '800': '#386a56',
  '900': '#284d3e',
};

export const neutral = {
  '50': '#ffffff',
  '100': '#fafafa',
  '200': '#f1f1f1',
  '300': '#e4e4e4',
  '400': '#d2d2d2',
  '500': '#b7b7b7',
  '600': '#959595',
  '700': '#6c6c6d',
  '800': '#3e3f43',
  '900': '#15161c',
};
